<!-- src/apps/secret/components/layout/SecretModeTabs.vue -->
<!-- secrets-files fork: pestañas Texto / Archivos para la barra superior. -->

<script setup lang="ts">
  import { computed } from 'vue';
  import { useRoute } from 'vue-router';
  import { useProductIdentity } from '@/shared/stores/identityStore';

  const route = useRoute();
  const { primaryColor } = useProductIdentity();

  // /file y /file/:id → modo archivos; todo lo demás (/) → modo texto.
  const isFiles = computed(() => route.path.startsWith('/file'));

  const base =
    'border-b-2 pb-1 text-base font-medium transition-colors duration-150';
  const inactive =
    'border-transparent text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200';
</script>

<template>
  <nav
    class="mb-8 flex justify-center gap-8"
    aria-label="Modo de envío">
    <router-link
      to="/"
      data-testid="mode-tab-text"
      :class="[base, isFiles ? inactive : 'font-semibold']"
      :style="isFiles ? undefined : { color: primaryColor, borderColor: primaryColor }">
      Texto
    </router-link>
    <router-link
      to="/file"
      data-testid="mode-tab-files"
      :class="[base, isFiles ? 'font-semibold' : inactive]"
      :style="isFiles ? { color: primaryColor, borderColor: primaryColor } : undefined">
      Archivos
    </router-link>
  </nav>
</template>
